import { render, staticRenderFns } from "./IconClick.vue?vue&type=template&id=71acb690"
import script from "./IconClick.vue?vue&type=script&lang=js"
export * from "./IconClick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports